import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  CustomColors
} from '../../constants';

const InputBox = styled.input`
  display: flex;
  flex: 1 0 auto;
  color: ${CustomColors.Grey11};
  font-size: 26px;
  line-height: 23.4px;
  padding: 0;
  margin: 0;
  min-width: 0;
  width: 80%;
  background: none;
  border: none;
  outline: none;
  text-align: center;
  font-weight: bold;
  -moz-appearance: textfield;

  &::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const InputOtpBox = props => {

  const inputRef = React.useRef();

  React.useEffect(() => {

    if (props.focus) {
      inputRef.current?.focus?.();
    }
  }, [ props.focus, inputRef ]);

  const handleChange = (e) => {

    if (!e || !e.target) {
      return;
    }

    props.onChange?.(e.target.value);
  };

  const handleKeyDown = (e) => {

    const isValid = /\d|Backspace|Enter/.test(e?.key);

    if (!isValid) {

      e.preventDefault();
      return;
    }

    props.onKeyDown?.(e);
  };

  return (

    <InputBox
      ref={inputRef}
      onChange={handleChange}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      value={props.value}
      type={'text'}
      inputMode={'numeric'}
      onKeyDown={handleKeyDown}/>
  );
};

InputOtpBox.propTypes = {
  focus: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func
};

InputOtpBox.defaultProps = {
  focus: false,
  onFocus: () => {},
  onBlur: () => {},
  onKeyDown: () => {}
};
